import React from 'react';
import { BiCalendar } from 'react-icons/bi';
import TitleBlock from '../TitleBlock';
import SelectField from '../SelectField';
import { useCollection, useStateSelector } from '../../state';
import { selectDate } from '../../utils';
import styles from './index.module.scss';

const Header = ({ onChange }) => {
  const collection = useCollection();

  const value = useStateSelector(selectDate);

  const currentMonth = value?.getParent();
  const currentYear = currentMonth?.getParent();

  return (
    <header className={styles.root}>
      <TitleBlock
        icon={<BiCalendar />}
        title="Выбрать дату"
        description={value?.date?.format('dddd, D MMMM YYYY')}
      />
      <div className={styles.actions}>
        <SelectField
          items={currentYear?.children}
          selectedItems={currentMonth?.id ? [currentMonth.id] : undefined}
          btnText={value?.date?.format('MMM')}
          onChange={onChange}
        />
        <SelectField
          items={collection?.getYears()}
          selectedItems={currentYear?.id ? [currentYear.id] : undefined}
          btnText={value?.date?.format('YYYY')}
          onChange={onChange}
        />
      </div>
    </header>
  );
};

export default Header;
